//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'
import ChevronLeftIcon from 'vue-material-design-icons/ChevronLeft.vue'
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue'

const USER_ARTICLES = gql`
  query UserArticles($after: String, $first: Int, $where: UserArticleFilterInput) {
    userArticles(after: $after, first: $first, where: $where) {
      nodes {
        id
        article {
          id
          externalId
          date
          title
          slug
          abstract
          imageUrl
          redirectUrl
          edition {
            id
            name
          }
          country {
            id
            name
          }
          region {
            id
            name
          }
          contentType {
            id
            name
            colour
            contentTypeGroup {
              id
              name
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`

const DELETE_MANY_USER_ARTICLES = gql`
  mutation ($data: DeleteManyUserArticlesInput) {
    deleteManyUserArticles(data: $data) {
      id
    }
  }
`

export default {
  components: { ChevronRightIcon, ChevronLeftIcon },
  scrollToTop: true,
  data() {
    return {
      loading: false,
      isRemoving: false,
      isDownloading: false,
      selected: {},
      pagination: {
        total: 0,
        pageSize: 15,
        page: 1
      },
      userArticles: [],
      placeholders: 4
    }
  },
  computed: {
    bookmarkArticleIds() {
      return this.$store.get('bookmark/articleIds') || []
    }
  },
  async mounted() {
    this.setBreadcrumb({
      isShow: true,
      pageTitle: this.$t('article_binder.article_binder')
    })

    this.setFilters({
      isShow: false,
      showFilterTotal: false,
      header: this.$t('article_binder.article_binder'),
      isCardHeader: true
    })

    await this.refresh()
  },
  methods: {
    async refresh() {
      this.loading = true
      const first = this.pagination.pageSize

      let after = null
      if (this.pagination.page > 1) {
        const id = this.pagination.pageSize * (this.pagination.page - 1) - 1
        after = this.encodeValue(id)
      }

      try {
        const {
          data: {
            userArticles: { nodes, totalCount }
          }
        } = await this.$apollo.query({
          query: USER_ARTICLES,
          variables: {
            first,
            after
          },
          fetchPolicy: 'network-only'
        })

        this.userArticles = nodes
        this.pagination.total = totalCount
        this.selected = {}
      } catch (error) {
        this.handleError(error)
      } finally {
        this.loading = false
      }
    },
    async onRemoveClick() {
      try {
        this.isRemoving = true

        const removed = Object.keys(this.selected)
          .filter((x) => this.selected[x] === true)
          .map((x) => parseInt(x))

        await this.$apollo.mutate({
          mutation: DELETE_MANY_USER_ARTICLES,
          variables: {
            data: {
              articleIds: removed
            }
          }
        })

        const bookmarked = this.bookmarkArticleIds.filter((x) => !removed.includes(x))
        this.userArticles = this.userArticles.filter((x) => !removed.includes(x.article.id))
        this.pagination.total = bookmarked.length
        this.$store.set('bookmark/articleIds', bookmarked)

        await this.refresh()
      } catch (err) {
        this.$buefy.notification.open({
          duration: 5000,
          message: this.$t('article_binder.error_not_removed'),
          type: 'is-danger'
        })
      } finally {
        this.isRemoving = false
      }
    },
    async onExportTextClick() {
      this.isDownloading = true
      await this.$axios
        .$get(`/download/article-binder`, { responseType: 'blob' })
        .then((res) => {
          const url = window.URL.createObjectURL(res)
          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = 'article-binder.txt'
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
        })
        .catch((err) => console.log(err))

      this.isDownloading = false
    },
    async onExportHtmlClick() {
      this.isDownloading = true
      await this.$axios
        .$get(`/download/article-binder-html`, { responseType: 'blob' })
        .then((res) => {
          const url = window.URL.createObjectURL(res)
          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = 'article-binder.html'
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
        })
        .catch((err) => console.log(err))

      this.isDownloading = false
    },
    async onPaginationChange() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
      await this.refresh()
    },
    onSelectAll() {
      this.userArticles.forEach((x) => {
        this.$set(this.selected, x.article.id, true)
      })

      this.$emit('update:selected', this.selected)
    },
    onSelectNone() {
      this.userArticles.forEach((x) => {
        this.$set(this.selected, x.article.id, false)
      })

      this.$emit('update:selected', this.selected)
    }
  }
}
